import { downgradeInjectable } from '@angular/upgrade/static';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GenericService } from 'src/app/core/services/generic.service';
import { JobService } from 'src/app/core/services/job.service';
import { UserService } from 'src/app/core/services/user.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { UserCommunicationService } from 'src/app/core/services/user-communication.service';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { FeedbackAuthoringService } from 'src/app/core/services/feedback-authoring.service';
// import { FeedbackExecutionService } from 'src/app/core/services/feedback-execution.service';
import { BrowserService } from 'src/app/core/services/browser.service';
import { DebounceService } from 'src/app/core/services/debounce.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { StateHistoryService } from 'src/app/core/services/state-history.service';
import { DocumentService } from 'src/app/core/services/document.service';
// import { MeetingService } from 'src/app/core/services/meeting.service';
import { AppVersionService } from 'src/app/core/services/app-version.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { LoginService } from 'src/app/pages/login-page/login.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { DocumentActionService } from 'src/app/core/services/document-action-service';
import { EntityActivitiesService } from 'src/app/core/services/entity-activities.service';
import { SettingService } from 'src/app/core/services/setting.service';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';
import { OutreachService } from 'src/app/core/services/outreach.service';
import { LlmIntegrationService } from 'src/app/core/services/llm-integration.service';
export var ServicesModuleAjs = angular.module('4dot5.missioncontrol.servicesModuleAjs', [])
    .factory('dateTimeUtilityService', downgradeInjectable(DateTimeUtilityService))
    .factory('authService', downgradeInjectable(AuthService))
    .factory('userRoleService', downgradeInjectable(UserRoleService))
    .factory('StorageService', downgradeInjectable(StorageService))
    .factory('genericService', downgradeInjectable(GenericService))
    .factory('jobService', downgradeInjectable(JobService))
    .factory('userService', downgradeInjectable(UserService))
    .factory('companyService', downgradeInjectable(CompanyService))
    .factory('planService', downgradeInjectable(PlanService))
    .factory('candidateService', downgradeInjectable(CandidateService))
    .factory('notificationsService', downgradeInjectable(NotificationsService))
    .factory('jobMatchService', downgradeInjectable(JobMatchService))
    .factory('resumeService', downgradeInjectable(ResumeService))
    .factory('userCommunicationService', downgradeInjectable(UserCommunicationService))
    .factory('employeeService', downgradeInjectable(EmployeeService))
    .factory('assessmentService', downgradeInjectable(AssessmentService))
    .factory('feedbackAuthoringService', downgradeInjectable(FeedbackAuthoringService))
    // .factory('feedbackExecutionService', downgradeInjectable(FeedbackExecutionService))
    .factory('browserService', downgradeInjectable(BrowserService))
    .factory('debounceService', downgradeInjectable(DebounceService))
    .factory('stateManagementStorageService', downgradeInjectable(StateManagementStorageService))
    .factory('stateHistoryService', downgradeInjectable(StateHistoryService))
    .factory('alertsAndNotificationsService', downgradeInjectable(AlertAndNotificationsService))
    .factory('documentService', downgradeInjectable(DocumentService))
    // .factory('meetingService', downgradeInjectable(MeetingService))
    .factory('appVersionService', downgradeInjectable(AppVersionService))
    .factory('utilityService', downgradeInjectable(UtilityService))
    .factory('loginService', downgradeInjectable(LoginService))
    .factory('sharedService', downgradeInjectable(SharedService))
    .factory('documentActionService', downgradeInjectable(DocumentActionService))
    .factory('entityActivitiesService', downgradeInjectable(EntityActivitiesService))
    .factory('settingService', downgradeInjectable(SettingService))
    .factory('manageSkillsService', downgradeInjectable(ManageSkillsService))
    .factory('outreachService', downgradeInjectable(OutreachService))
    .factory('llmIntegrationService', downgradeInjectable(LlmIntegrationService))
    .name;
//# sourceMappingURL=service.module.ajs.js.map